/* global $:false */

export default class Slidebar {
  static init () {
    Array.from($('.js-slidebar')).map((el) =>
      new Slidebar(el))
  }

  constructor (el) {
    this.close = this.close.bind(this)
    this.el = $(el)
    this.readDataAttributes()
    this.findElements()
    this.setupBindings()
  }

  readDataAttributes () {
    this.id = this.el.data('slidebar-id')
  }

  findElements () {
    this.showButton = $(`.js-slidebar-trigger[data-slidebar-id='${this.id}']`)
  }

  setupBindings () {
    this.showButton.click((event) => {
      event.preventDefault()
      this.el.addClass('o-slidebar--expanded')
    })

    // The third argument `true` reverses the event bubbling order.
    // Instead of the innermost element, we capture the outermost first.
    // Basically, we want to react to a click before any other side-effects.
    // Inspired by https://stackoverflow.com/a/153047
    // Improved by https://stackoverflow.com/a/49627858
    window.addEventListener('click', this.close, true)
  }

  close (event) {
    // When clicked inside the sidebar, do nothing.
    if ($(event.target).closest('.js-slidebar').length) { return }
    // When the sidebar is already closed, do nothing.
    if (!this.el.hasClass('o-slidebar--expanded')) { return }

    // Close the sidebar.
    this.el.removeClass('o-slidebar--expanded')
    // Prevent *anything* else from happening, such as links reacting.
    event.preventDefault()
    event.stopPropagation()
  }
}
